import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { SocketProvider } from '../../providers/socket/socket';

@Component({
  selector: 'page-title',
  templateUrl: 'title.html',
  // providers: [SocketProvider]
})
export class TitlePage {
  connected = false;
  gameNumber;
  name;
  background;
  constructor(public navCtrl: NavController, private socketProvider: SocketProvider) {
    this.background = '../../assets/imgs/background/' + this.socketProvider.getRandomBackground();
  }

  createGame() {
    this.socketProvider.isHost = true;
    this.socketProvider.name = this.name;
    console.log("creating game");
    this.socketProvider.sendMessage({
      name: this.name,
      action:'create'
    });
  }

  joinGame() {
    this.socketProvider.name = this.name;
    this.socketProvider.roomNumber = this.gameNumber;
    console.log("joining game");
    this.socketProvider.sendMessage({
      name: this.name,
      action: 'join',
      room: this.gameNumber
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/title/title.ts